module.exports = __webpack_public_path__ + "static/media/Pin_Job_Lockout.9bd967f8.svg";